module.exports = __webpack_public_path__ + "static/media/introImage.1fd971eb.png";